var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import { SaveStatus, } from 'lib-shared-legacy-types';
import memoize from 'memoize-one';
import { PureComponent } from 'react';
import { analytics } from 'app/utils/segment';
import { FiltersNodePhone, IntegrationNodeCall, OpeningHoursNode, TagsNode, } from 'components/powerFlowShared/components/nodeTypes';
import { BusinessHoursPhoneNodeAttributes } from 'components/powerFlowShared/components/nodeTypes/canvas/businesshours';
import { FiltersNodePhoneAttributes } from 'components/powerFlowShared/components/nodeTypes/canvas/filters';
import { InitNodePhoneAttributes } from 'components/powerFlowShared/components/nodeTypes/canvas/init';
import { IntegrationNodePhoneAttributes } from 'components/powerFlowShared/components/nodeTypes/canvas/integration';
import { OpeningHoursDeprecatedNodeAttributes } from 'components/powerFlowShared/components/nodeTypes/canvas/openingHours';
import { QueueNodePhoneAttributes } from 'components/powerFlowShared/components/nodeTypes/canvas/queue';
import { TagsNodeAttributes } from 'components/powerFlowShared/components/nodeTypes/canvas/tags';
import { ScheduleFetch } from 'components/powerFlowShared/components/scheduleFetch';
import { TagFetch } from 'components/powerFlowShared/components/tagFetch';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getActionNodes } from 'components/powerFlowShared/helpers/getInvalidNodes';
import { FlowEditorChrome, FlowType } from 'fable/flowEditor';
import TopbarButtons from '../containers/topbarButtons';
import { AudioMessageNode, CallbackNode, DialInputNode, ForwardNode, InitNode, IVRNode, LocationsNode, QueueNode, RecordConversationNode, VoicemailNode, } from './nodeTypes';
import { AudioMessageNodeAttributes } from './nodeTypes/canvas/audioMessage';
import { CallbackNodeAttributes } from './nodeTypes/canvas/callback';
import { DialInputNodeAttributes } from './nodeTypes/canvas/dialInput';
import { ForwardNodeAttributes } from './nodeTypes/canvas/forward';
import { IVRNodeAttributes } from './nodeTypes/canvas/ivr';
import { LocationsNodeAttributes } from './nodeTypes/canvas/locations';
import { RecordConversationNodeAttributes } from './nodeTypes/canvas/recordConversation';
import { VoicemailNodeAttributes } from './nodeTypes/canvas/voicemail';
import '../styles/call-flow.less';
class PowerCallFlow extends PureComponent {
    constructor(props) {
        super(props);
        this.getFullFlowMemo = memoize((isLocal, id, name, actions, active, number, agentDisplayName) => {
            return {
                id,
                location: isLocal ? 'local' : number,
                number: isLocal ? 'local' : number,
                name: name || 'Name your flow',
                actions: actions || [],
                active: isLocal ? false : active,
                updated_by: agentDisplayName || null,
            };
        });
        this.getExtraData = memoize((number, tags, schedules, announcements, queuesState, agentDisplayName) => ({
            number,
            tags,
            schedules,
            announcements,
            queues: queuesState ? queuesState.queues : [],
            agentDisplayName,
        }));
        const { isCanvasEnabled, isIntegrationsEnabled } = props;
        this.state = {
            actions: null,
            active: true,
            errorMessage: null,
            invalidNodes: null,
            name: '',
            nodeTypes: isCanvasEnabled
                ? Object.assign(Object.assign({ init: InitNodePhoneAttributes, 
                    // GREEN - Termination -> Queue
                    queue: QueueNodePhoneAttributes, forward: ForwardNodeAttributes, voicemail: VoicemailNodeAttributes, 
                    // RED - Termination -> Closed
                    announcement: AudioMessageNodeAttributes, 
                    // PURPLE - Splitters
                    externaldatarouting: FiltersNodePhoneAttributes, phonenumber: LocationsNodeAttributes, ivrmenu: IVRNodeAttributes, [FlowNodeTypes.OPENING_HOURS]: OpeningHoursDeprecatedNodeAttributes, [FlowNodeTypes.BUSINESS_HOURS]: BusinessHoursPhoneNodeAttributes, 
                    // ORANGE - Input required
                    callback: CallbackNodeAttributes, externaldataphoneinput: DialInputNodeAttributes, 
                    // BLUE - Other
                    callrecording: RecordConversationNodeAttributes }, (isIntegrationsEnabled
                    ? { [FlowNodeTypes.INTEGRATION]: IntegrationNodePhoneAttributes }
                    : {})), { tags: TagsNodeAttributes }) : Object.assign(Object.assign({ init: InitNode, 
                // GREEN - Termination -> Queue
                queue: QueueNode, forward: ForwardNode, voicemail: VoicemailNode, 
                // RED - Termination -> Closed
                announcement: AudioMessageNode, 
                // PURPLE - Splitters
                externaldatarouting: FiltersNodePhone, phonenumber: LocationsNode, ivrmenu: IVRNode, openinghours: OpeningHoursNode, 
                // ORANGE - Input required
                callback: CallbackNode, externaldataphoneinput: DialInputNode, 
                // BLUE - Other
                callrecording: RecordConversationNode }, (isIntegrationsEnabled
                ? { [FlowNodeTypes.INTEGRATION]: IntegrationNodeCall }
                : {})), { tags: TagsNode }),
            number: '',
            ready: false,
            saveStatus: SaveStatus.Saved,
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (props.status === 'complete' && !state.number) {
            // flow is ready, and hasn't been initialized yet..
            // we update flow info in state
            return {
                actions: props.flowData.actions,
                active: props.flowData.active,
                name: props.flowData.name,
                number: props.flowData.number,
                ready: true,
                saveStatus: SaveStatus.Saved,
            };
        }
        if (props.status === 'error') {
            return { saveStatus: SaveStatus.Failed };
        }
        if (props.status === 'complete' &&
            (state.saveStatus === SaveStatus.Saving ||
                state.saveStatus === SaveStatus.Failed)) {
            return { saveStatus: SaveStatus.Saved };
        }
        // no change
        return null;
    }
    componentDidMount() {
        this.props.fetchFlow(this.props.id);
        this.props.getNumbersByQuery({ query: { limit: '15' } });
        this.props.getAllNumbers();
        this.props.getAllQueues();
        this.props.getAllAudios();
        this.props.flowGetLanguages({
            flowID: this.props.id || 'local',
        });
    }
    componentWillUnmount() {
        this.props.flushFlow();
    }
    hasUnsavedChanges() {
        const { saveStatus } = this.state;
        const { id } = this.props;
        return !id || saveStatus <= 0;
    }
    handleNumberChange(phoneNumber) {
        if (this.state.number !== phoneNumber.e164_format) {
            analytics.flowPhoneNumberChanged();
            this.setState({
                number: phoneNumber.e164_format,
                saveStatus: SaveStatus.Unsaved,
            });
        }
    }
    handleOnChange({ name, actions, active, }) {
        if (!this.hasUnsavedChanges() ||
            this.state.name !== name ||
            this.state.actions !== actions ||
            this.state.active !== active) {
            this.setState({
                actions,
                active,
                invalidNodes: null,
                name,
                saveStatus: SaveStatus.Unsaved,
            });
        }
    }
    deleteLocally() {
        this.props.removeLocalFlow();
    }
    getFullFlow(isLocal = false) {
        const { name, actions, active, number } = this.state;
        const { id = 'local', agentDisplayName } = this.props;
        return this.getFullFlowMemo(isLocal, id || 'local', name, actions, active, number, agentDisplayName);
    }
    handleOnSave() {
        const { number, actions } = this.state;
        const invalidNodes = actions && getActionNodes(actions);
        if (invalidNodes === null || invalidNodes === void 0 ? void 0 : invalidNodes.length) {
            this.setState({
                errorMessage: null,
                invalidNodes,
            });
        }
        else if (!number || number === 'local') {
            this.setState({
                errorMessage: 'No number selected',
            });
        }
        else {
            this.setState({
                errorMessage: null,
                invalidNodes: null,
                saveStatus: SaveStatus.Saving,
            }, this.updateFlow);
        }
    }
    updateFlow() {
        const { flowData } = this.props;
        const fullFlow = this.getFullFlow();
        // this.props[method](fullFlow, flowData.actions);
        this.props.updateFlow(fullFlow, flowData.actions);
        this.deleteLocally();
    }
    handleOnActivate() {
        this.setState({
            active: true,
            errorMessage: null,
        }, this.updateFlow);
    }
    render() {
        const { announcements, flowData, queuesState, agentDisplayName } = this.props;
        const { ready, number, invalidNodes, actions, errorMessage, nodeTypes } = this.state;
        return (_jsx(TagFetch, { actions: actions, render: (tags) => (_jsx(ScheduleFetch, { actions: actions, render: (schedules) => (_jsx("div", Object.assign({ className: "powercallflow-container" }, { children: ready && (_jsx(FlowEditorChrome, { errorMessage: errorMessage, extraData: this.getExtraData(number, tags.items, schedules, announcements, queuesState, agentDisplayName), flowType: FlowType.FLOW_TYPE_CALL, goBackPath: "/settings/phone", hasUnsavedChanges: this.hasUnsavedChanges(), initialData: flowData, invalidNodes: invalidNodes, nodeTypes: nodeTypes, onActivate: this.handleOnActivate, onChange: this.handleOnChange, onSave: this.handleOnSave, topleftButtonComponent: TopbarButtons, topleftButtonComponentProps: {
                            changeNumber: this.handleNumberChange,
                        } })) }))) })) }));
    }
}
__decorate([
    boundMethod
], PowerCallFlow.prototype, "hasUnsavedChanges", null);
__decorate([
    boundMethod
], PowerCallFlow.prototype, "handleNumberChange", null);
__decorate([
    boundMethod
], PowerCallFlow.prototype, "handleOnChange", null);
__decorate([
    boundMethod
], PowerCallFlow.prototype, "deleteLocally", null);
__decorate([
    boundMethod
], PowerCallFlow.prototype, "getFullFlow", null);
__decorate([
    boundMethod
], PowerCallFlow.prototype, "handleOnSave", null);
__decorate([
    boundMethod
], PowerCallFlow.prototype, "updateFlow", null);
__decorate([
    boundMethod
], PowerCallFlow.prototype, "handleOnActivate", null);
export default PowerCallFlow;
